import { connect } from 'react-redux'

import ProfileBankForm from 'app/session/bc_profile/bank_container'

export default connect()(ProfileBankForm)
